import { render, staticRenderFns } from "./DamPredictionMobile.vue?vue&type=template&id=3748a563&scoped=true"
import script from "./DamPredictionMobile.vue?vue&type=script&lang=ts"
export * from "./DamPredictionMobile.vue?vue&type=script&lang=ts"
import style0 from "./DamPredictionMobile.vue?vue&type=style&index=0&id=3748a563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748a563",
  null
  
)

export default component.exports